export const aprilUppercase = "tqa";
export default {aprilUppercase};